import React from "react";
import ReportsDetails from "./ReportsDetails";

const FTSReport = () => {
  return <ReportsDetails />;
};

export default FTSReport;
